import React, {useCallback, useEffect, useState} from 'react';
import {Col, Layout, Row} from 'antd';
import {Outlet, useLocation} from "react-router-dom";
import ProHeader from "../components/ProHeader";
import ProFooter from "../components/ProFooter";
import mobileImg from './Mobile Holding Image.webp'
import useWindowResize from "../../apps/Hooks/useWindowResize";
import {NewHeader} from "../../components/NewHeader";
import PageFooter from "../../components/Footer/PageFooter";

const {Content} = Layout;

function ProLayout() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log(userAgent)
    return (
        // /Android|iPad|iPhone|iPod/.test(userAgent) ?
        //     <img src={mobileImg}
        //          alt={'thanks!'}
        //          style={{width: '100vw', height: '100vh'}}
        //     /> :
            <div>
                {/*<ProHeader/>*/}
                <NewHeader/>
                <Layout className="layout" style={{width: '100%'}}>
                    <Content>
                        <Outlet/>
                    </Content>
                </Layout>
                <PageFooter/>
            </div>
    );
}

export default ProLayout;